export default {
  materials: [
    {
      code: "EPDM",
      name: "EPDM (Ethylene-Propylene Rubber)",
      fullName: "Ethylene Propylene Diene Monomer",
      icon: "ri-sun-line",
      color: "bg-accent-500",
      properties: {
        "Heat Resistance": "★★★★★ (up to 150℃)",
        "Cold Resistance": "★★★★☆ (-50℃)",
        "Weather Resistance": "★★★★★",
        "Ozone Resistance": "★★★★★",
        "Oil Resistance": "★☆☆☆☆",
        "Abrasion Resistance": "★★★☆☆",
        "Tensile Strength": "★★★☆☆ (8~20 MPa)",
      },
      features: [
        "Excellent heat, weather, and ozone resistance",
        "Outstanding electrical insulation",
        "Good resistance to polar solvents",
        "Maintains flexibility at low temperatures",
      ],
      applications: ["Automotive weather strips", "Architectural sealing gaskets", "Heat exchanger gaskets", "Coolant hoses", "Wire insulation"],
      desc: "The most widely used general-purpose rubber material, delivering excellent performance especially in outdoor and high-temperature environments. Its superior weather and ozone resistance makes it ideal for prolonged exposure to sunlight and ozone.",
    },
    {
      code: "NBR",
      name: "NBR (Nitrile Rubber)",
      fullName: "Acrylonitrile Butadiene Rubber",
      icon: "ri-oil-line",
      color: "bg-primary-500",
      properties: {
        "Heat Resistance": "★★★★☆ (up to 120℃)",
        "Cold Resistance": "★★☆☆☆ (-30℃)",
        "Weather Resistance": "★★☆☆☆",
        "Ozone Resistance": "★★☆☆☆",
        "Oil Resistance": "★★★★★",
        "Abrasion Resistance": "★★★★☆",
        "Tensile Strength": "★★★★☆ (10~25 MPa)",
      },
      features: [
        "Excellent oil and solvent resistance",
        "Good mechanical strength and abrasion resistance",
        "Tunable properties via acrylonitrile content",
        "Low gas permeability",
      ],
      applications: ["Oil seals, fuel hoses", "Hydraulic equipment packing", "Industrial rollers", "Fuel tank gaskets", "Oil-resistant packing"],
      desc: "The most commonly used rubber material for oil-resistant applications. The balance of oil and cold resistance can be adjusted via acrylonitrile (ACN) content to handle various oil and fuel environments.",
    },
    {
      code: "CR",
      name: "CR (Chloroprene Rubber)",
      fullName: "Chloroprene Rubber (Neoprene)",
      icon: "ri-fire-line",
      color: "bg-secondary-500",
      properties: {
        "Heat Resistance": "★★★★☆ (up to 120℃)",
        "Cold Resistance": "★★★☆☆ (-40℃)",
        "Weather Resistance": "★★★★☆",
        "Ozone Resistance": "★★★★☆",
        "Oil Resistance": "★★★☆☆",
        "Abrasion Resistance": "★★★★☆",
        "Tensile Strength": "★★★★☆ (15~25 MPa)",
      },
      features: [
        "Excellent balance of weather, ozone, and heat resistance",
        "Flame retardant, suitable for fire-safety environments",
        "Good adhesion for bonding with metal",
        "Oil and chemical resistance",
      ],
      applications: ["Anti-vibration rubber", "Conveyor belts", "Architectural gaskets", "Cable sheaths", "Adhesives"],
      desc: "A versatile rubber material with balanced properties. Its flame retardancy makes it widely used in environments where fire safety is critical, such as construction, ships, and mining.",
    },
    {
      code: "SBR",
      name: "SBR (Styrene Butadiene Rubber)",
      fullName: "Styrene Butadiene Rubber",
      icon: "ri-caravan-line",
      color: "bg-foreground-500",
      properties: {
        "Heat Resistance": "★★★☆☆ (up to 100℃)",
        "Cold Resistance": "★★★☆☆ (-50℃)",
        "Weather Resistance": "★★☆☆☆",
        "Ozone Resistance": "★★☆☆☆",
        "Oil Resistance": "★☆☆☆☆",
        "Abrasion Resistance": "★★★★★",
        "Tensile Strength": "★★★☆☆ (5~20 MPa)",
      },
      features: ["Excellent abrasion resistance", "Excellent processability and economy", "Easy property tuning via fillers", "Excellent price competitiveness"],
      applications: ["Tire treads", "Shoe soles", "Conveyor belts", "General industrial rubber products", "Anti-vibration pads"],
      desc: "The most economical general-purpose rubber material, particularly suited to applications requiring abrasion resistance. Widely used as a substitute for natural rubber, with mechanical properties greatly enhanced through carbon black compounding.",
    },
    {
      code: "FKM",
      name: "FKM (Fluororubber / Viton)",
      fullName: "Fluoroelastomer (Viton®)",
      icon: "ri-test-tube-line",
      color: "bg-accent-500",
      properties: {
        "Heat Resistance": "★★★★★ (up to 250℃)",
        "Cold Resistance": "★★☆☆☆ (-20℃)",
        "Weather Resistance": "★★★★★",
        "Ozone Resistance": "★★★★★",
        "Oil Resistance": "★★★★★",
        "Abrasion Resistance": "★★★☆☆",
        "Tensile Strength": "★★★☆☆ (8~15 MPa)",
      },
      features: [
        "Top performance in ultra-high-temperature and extreme chemical environments",
        "Resistance to almost all chemicals",
        "Best-in-class long-term durability and reliability",
        "Minimal outgassing in vacuum environments",
      ],
      applications: ["Chemical plant seals", "Semiconductor equipment seals", "Aerospace parts", "High-temperature valve seats", "Nuclear facility gaskets"],
      desc: "A premium specialty rubber material that withstands extreme temperatures and chemical environments. Although costly, it is essential in extreme environments that cannot be replaced by other materials. We operate a production line specialized in compression molding of FKM materials.",
    },
    {
      code: "VMQ",
      name: "Silicone Rubber (VMQ)",
      fullName: "Silicone Rubber (VMQ)",
      icon: "ri-cpu-line",
      color: "bg-secondary-500",
      properties: {
        "Heat Resistance": "★★★★★ (up to 230℃)",
        "Cold Resistance": "★★★★★ (-100℃)",
        "Weather Resistance": "★★★★★",
        "Ozone Resistance": "★★★★★",
        "Oil Resistance": "★★☆☆☆",
        "Abrasion Resistance": "★★☆☆☆",
        "Tensile Strength": "★★☆☆☆ (4~10 MPa)",
      },
      features: [
        "Widest operating temperature range from ultra-low to high temperatures",
        "Excellent biocompatibility (medical grade)",
        "Outstanding electrical insulation",
        "Transparent and translucent molding available",
      ],
      applications: ["Medical device parts", "Electrical insulation seals", "Food processing equipment packing", "Waterproof seals (IP67/68)", "Baby care products"],
      desc: "A high-performance material featuring human safety and a wide operating temperature range. Essential in fields requiring high purity such as medical, food, and electronics, and we can mold food-grade and medical-grade silicone rubber.",
    },
  ],
  quotationGuide: {
    title: "Quotation Guide",
    desc: "We provide optimal quotes quickly by accurately understanding your requirements. Providing the items below allows for more accurate pricing.",
    requiredInfo: [
      "Product drawing or sketch (PDF, DWG, JPG)",
      "Required quantity (estimated monthly usage)",
      "Application environment (temperature, contact fluid, pressure, etc.)",
      "Required properties (hardness, tensile strength, heat resistance, etc.)",
      "Desired delivery date",
    ],
    process: [
      { step: 1, title: "Inquiry Received", desc: "Received via phone, email, or the quote board" },
      { step: 2, title: "Drawing Review", desc: "Engineer reviews drawings/specs and recommends materials" },
      { step: 3, title: "Quote Sent", desc: "Quote emailed within 2-3 business days" },
      { step: 4, title: "Consultation & Adjustment", desc: "Quantity, delivery, and spec negotiation with final quote confirmation" },
    ],
  },
  page: {
    title: "Technical Data",
    subtitle: "Sharing rubber material expertise and technical know-how",
    materialsTab: "Rubber Materials",
    downloadsTab: "Technical Downloads",
    featuresTitle: "Key Features",
    applicationsTitle: "Applications",
    propertiesTitle: "Properties",
    inquiryMaterial: "Inquire About This Material",
    total: "{{count}} items",
    searchPlaceholder: "Search by title or category",
    empty: "No search results found.",
    download: "Download",
    loading: "Loading...",
    fetchError: "Failed to load data.",
    retry: "Try Again",
  },
};